import { Component, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { combineLatest, Observable, timer } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Context } from 'src/app/context';
import { BrandModel } from 'src/app/models/brand.model';
import { AuthService } from 'src/app/services/auth.service';
import { InstallService } from 'src/app/services/install.service';
import { ShowLoading } from 'src/app/utils/show-loading';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss'],
})
export class SplashScreenComponent implements OnInit {

  grayscale = true;
  hide = false;
  showSplash = true;
  brand: BrandModel;
  baseUrl = environment.baseUrl;

  loaded$: Observable<{ showContinue: boolean }>;

  @Output() public loaded = new EventEmitter();

  constructor(
    private installService: InstallService,
    private renderer: Renderer2,
    private platform: Platform,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    this.brand = Context.brand;
    setTimeout(() => this.grayscale = false, 500);
    const isIos = this.platform.is('ios');

    this.loaded$ = combineLatest([
      this.installService.installed$,
      timer(2000)])
      .pipe(
        take(1),
        switchMap(async ([installed]) => {
          if (installed) {
            await this.hideSplash();
            return { showContinue: false };
          }
          else if (isIos) {
            await this.continue();
            return { showContinue: false };
          }
          else
            return { showContinue: true };
        })
      );
  }

  async continue() {
    await this.installService.promptInstall();

    await this.hideSplash();
  }

  async hideSplash() {
    if (!await this.checkCustomLogin())
      return;

    this.renderer.removeClass(document.body, 'init-loading');
    this.hide = true;

    setTimeout(() => {
      this.showSplash = false;
      this.loaded.emit(true);
    }, 500);
  }

  @ShowLoading()
  async checkCustomLogin() {
    const { code } = this.route.snapshot.queryParams;
    if (code) {
      try {
        await this.authService.verify(code);
        this.router.navigate(['/'], {
          queryParams: {},
          replaceUrl: true
        });

        return true;
      } catch {
        window.location.href = Context.brand.loginUrl;
      }
    }

    if (!Context.user && Context.brand.loginUrl) {
      window.location.replace(Context.brand.loginUrl);
      return false;
    }

    return true;
  }

}
